module.exports = __webpack_public_path__ + "static/media/bat2.9c6c20e3.png";